import { render, staticRenderFns } from "./JobListings.vue?vue&type=template&id=15a317f6&scoped=true&"
import script from "./JobListings.vue?vue&type=script&lang=js&"
export * from "./JobListings.vue?vue&type=script&lang=js&"
import style0 from "./JobListings.vue?vue&type=style&index=0&id=15a317f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a317f6",
  null
  
)

export default component.exports